import { connectedStore } from '../../store';
import constants from '../constants';
import interrupter from '../../interrupter';
import events from '../../utils/events';

const generateInterruptionEvent = (messageType, args) => {
  const store = connectedStore.get();
  const message = { action: messageType, data: args || {} };
  const isBlockingDisabled = Boolean(
    message.data.properties && message.data.properties[constants.SYMBOL_SETTING].disableBlocking
  );

  if (!isBlockingDisabled) {
    store.dispatch(interrupter.actions.block());
  }

  return events
    .emit(message)
    .then((data) => {
      if (!isBlockingDisabled) {
        store.dispatch(interrupter.actions.unblock());
      }
      return data;
    })
    .catch((error) => {
      if (!isBlockingDisabled) {
        store.dispatch(interrupter.actions.unblock());
      }
      throw error;
    });
};

export default generateInterruptionEvent;
